import React from "react";
import { useServicePopup, servicesData } from "./ServicePopupContext";

const ServiceArea = () => {
    const { openPopup } = useServicePopup();

    const handleServiceClick = (service) => {
        openPopup(service.id);
    };

    return (
        <div
            id={"service"}
            className="service-area relative"
            style={{ backgroundImage: `url(/assets/img/theme/x-bg.png)` }}
        >
            <div className="container mx-auto">
                <div className="section-title">
                    <h3>
                        Notre équipe d'experts dévoués et nos avocats partenaires spécialisés collaborent pour fournir des solutions juridiques rapides et personnalisés
                    </h3>
                    <h3 className="our-red-text">
                        Nos procédures à des prix imbattables
                    </h3>
                </div>
                <div className="section-title">
                    <span></span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                    {servicesData.map((service) => (
                        <div
                            className="overflow-hidden transform hover:scale-105 transition duration-300 justify-center cursor-pointer"
                            key={service.id}
                            onClick={() => handleServiceClick(service)}
                        >
                            <div className="service-card">
                                <div>
                                    <img
                                        src={service.url}
                                        alt={service.title}
                                        loading="lazy"
                                    />
                                </div>
                                <div className="service-text">
                                    <h3>
                                        <div className="service-title whitespace-normal ">
                                            {service.title}
                                        </div>
                                    </h3>
                                    <div className="h-32 overflow-hidden">
                                        <p>
                                            {service.description.length > 157
                                                ? `${service.description.substring(0, 157)}...`
                                                : service.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServiceArea;